import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDeleteMemberAttendanceMutation } from "src/services/react-query-apis/delete-member-attendance";
import { swalConfirm } from "src/utils/swalHelpers";

const ReAttendanceDeleteButton = ({ attendance }) => {
  const deleteReattendanceMutation = useDeleteMemberAttendanceMutation();

  return (
    attendance.re_attendance_id && (
      <span>
        <button
          onClick={async () => {
            if (await swalConfirm("本当によろしいですか？")) {
              deleteReattendanceMutation.mutate({
                attendanceId: attendance.id,
              });
            }
          }}
          className="btn btn-danger w-100 btn-sm-custom"
          disabled={deleteReattendanceMutation.isPending}
        >
          <FontAwesomeIcon icon="trash" />
        </button>
      </span>
    )
  );
};

export { ReAttendanceDeleteButton };
